import React, { useState } from 'react';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PaymentIcon from '@mui/icons-material/Payment';
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { connect } from 'trim-redux';
import { translate } from '../../../config/lang';
import { defaultVariables } from '../../../config';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {useTranslation} from "react-i18next";
import {currencySymbol} from "../../../config/values";
import NumberField from "../../components/elements/fields/NumberField";


const WithdrawMoneyDialog = ({ user, reload,classes,style }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
    const [error, setError] = useState('');
    const [amount, setAmount] = useState(user.wallet.amount);
    const [submitLoading, setSubmitLoading] = useState(false);
    const lowMoney = user.wallet.amount < 10;

    const handleChange = (val) => {
        setAmount(val);
        setError('');
    };

    const handleRequest = async () => {
        const data = new FormData();
        data.append('amount', amount);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`,
            },
        };

        try {
            await axios.post(`${defaultVariables.url}/wallets/withdraw`, data, config);
            enqueueSnackbar(t('yourWithdrawRequestSubmitted'), { variant: 'success' });
            setOpen(false);
            reload();
        } catch (error) {
            if (error.response.status === 403 && error.response.data === "has_pending_request") {
                enqueueSnackbar(t('youHavePendingWithdrawRequest'), { variant: 'warning' });
            }else if (error.response.status === 403 && error.response.data === "charity_request") {
                enqueueSnackbar(t('charityCantMakeWithdrawRequest'), { variant: 'warning' });
            } else {
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            }
            setSubmitLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        if (amount > 10) {
            handleRequest();
        } else {
            setError(t('wrongPrice'));
            setSubmitLoading(false);
        }
    };

    const openModal = () => {
        if (lowMoney) {
            enqueueSnackbar(t('cantWithdrawSmallerThan10'), { variant: 'warning' });
        } else {
            setOpen(true);
        }
    };

    return (
        <>
      {!isXs ? (
          <Button
              variant="outlined"
              color="primary"
              style={style}
              disabled={user.status !== "confirmed"}
              startIcon={<IndeterminateCheckBoxRoundedIcon />}
              onClick={openModal}
          >
              {t('withdrawMoney')}
          </Button>
      ) : (
          <IconButton disabled={user.status !== "confirmed"} color="primary" onClick={() => setOpen(true)}>
              <IndeterminateCheckBoxRoundedIcon />
          </IconButton>
      )}
            {user.status !== "confirmed" && (
                <Tooltip title={t('pleaseVerifyFirst')} arrow>
                    <IconButton color="secondary" component={Link} to="/account/details">
                        <WarningRoundedIcon />
                    </IconButton>
                </Tooltip>
            )}
            <Dialog fullWidth maxWidth="sm" open={open} onClose={() => setOpen(false)} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{t('withdrawMoney')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('withdrawMoneyDescription')}</DialogContentText>
            <NumberField
                fullWidth
                label={t('amount')}
                variant="outlined"
                value={amount}
                endAdornment={currencySymbol}
                decimals={2}
                min={0}
                max={user.wallet.amount}
                onChange={(res) => handleChange(res)}
                error={!!error}
                helperText={error}
                margin="normal"
            />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} variant="contained" color="primary" startIcon={<PaymentIcon />} disabled={submitLoading}>
            {t('withdrawRequest')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
    );
};

const mstp = (state) => ({
    user: state.user,
});

export default withStyles(Styles)(connect(mstp)(WithdrawMoneyDialog));
